import React from "react";
import { Plus, X } from "lucide-react";

export default function CreateOrderModal({
  open,
  onClose,
  orderCreateMessage,
  orderDraftItems,
  updateDraftItem,
  removeDraftItem,
  addDraftItem,
  masterProducts,
  orderNotes,
  setOrderNotes,
  submitOrderCreate,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 p-4">
      <div className="max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-[24px] bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-[#f8dde1] px-6 py-4">
          <div>
            <h3 className="text-[18px] font-bold text-slate-800">New Order Request</h3>
            <p className="mt-1 text-[13px] text-slate-500">
              Create warehouse stock request for admin
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-[10px] p-2 text-slate-500 hover:bg-slate-100"
          >
            <X size={18} />
          </button>
        </div>

        <div className="max-h-[72vh] overflow-y-auto px-6 py-5">
          {orderCreateMessage ? (
            <div className="mb-4 rounded-[14px] border border-[#f2c6cc] bg-[#fff8f9] px-4 py-3 text-[13px] font-medium text-[#d86a78]">
              {orderCreateMessage}
            </div>
          ) : null}

          <div className="space-y-3">
            {orderDraftItems.map((row, index) => (
              <div
                key={index}
                className="grid gap-3 rounded-[14px] border border-[#f2c6cc] bg-[#fffdfd] p-4 md:grid-cols-[1fr_140px_auto]"
              >
                <div>
                  <label className="mb-1 block text-[12px] font-semibold text-slate-500">
                    Product
                  </label>
                  <select
                    value={row.productId}
                    onChange={(e) => updateDraftItem(index, "productId", e.target.value)}
                    className="h-[42px] w-full rounded-[12px] border border-[#f2c6cc] px-3 text-[14px] outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f9dfe4]"
                  >
                    <option value="">Select product</option>
                    {masterProducts.map((product) => (
                      <option key={product.id} value={product.id}>
                        {(product.name || "Product") +
                          (product.sku ? ` (${product.sku})` : "")}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="mb-1 block text-[12px] font-semibold text-slate-500">
                    Variant
                  </label>
                  <select
                    value={row.productVariantId || ""}
                    onChange={(e) => updateDraftItem(index, "productVariantId", e.target.value)}
                    className="mb-3 h-[42px] w-full rounded-[12px] border border-[#f2c6cc] px-3 text-[14px] outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f9dfe4]"
                  >
                    <option value="">Select variant</option>
                    {(masterProducts.find((x) => String(x.id) === String(row.productId))?.variants || []).map((variant) => (
                      <option key={variant.id || variant.label} value={variant.id || ""}>
                        {variant.label || variant.variantName || variant.name || "Default"}
                      </option>
                    ))}
                  </select>
                  <label className="mb-1 block text-[12px] font-semibold text-slate-500">
                    Qty
                  </label>
                  <input
                    type="number"
                    min="1"
                    value={row.qty}
                    onChange={(e) => updateDraftItem(index, "qty", e.target.value)}
                    className="h-[42px] w-full rounded-[12px] border border-[#f2c6cc] px-3 text-[14px] outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f9dfe4]"
                  />
                </div>

                <div className="flex items-end">
                  <button
                    type="button"
                    onClick={() => removeDraftItem(index)}
                    disabled={orderDraftItems.length === 1}
                    className="inline-flex h-[42px] items-center gap-2 rounded-[12px] border border-[#f2c6cc] px-4 text-[13px] font-semibold text-slate-600 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    <X size={14} />
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-4">
            <button
              type="button"
              onClick={addDraftItem}
              className="inline-flex items-center gap-2 rounded-[12px] border border-[#f2c6cc] px-4 py-2.5 text-[13px] font-semibold text-slate-600 hover:bg-slate-50"
            >
              <Plus size={14} />
              Add Product Row
            </button>
          </div>

          <div className="mt-5">
            <label className="mb-2 block text-[13px] font-semibold text-slate-600">
              Notes
            </label>
            <textarea
              rows={4}
              value={orderNotes}
              onChange={(e) => setOrderNotes(e.target.value)}
              placeholder="Optional notes"
              className="w-full rounded-[14px] border border-[#f2c6cc] px-4 py-3 text-[14px] outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f9dfe4]"
            />
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 border-t border-[#f8dde1] px-6 py-4">
          <button
            type="button"
            onClick={onClose}
            className="rounded-[12px] border border-[#f2c6cc] px-5 py-2.5 text-[13px] font-semibold text-slate-600"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={submitOrderCreate}
            className="rounded-[12px] bg-[#d86a78] px-5 py-2.5 text-[13px] font-semibold text-white"
          >
            Submit Request
          </button>
        </div>
      </div>
    </div>
  );
}